/**
 * Import
 * - Libraries
 */
 import { connect } from 'react-redux'
 import { get } from 'lodash'
 
 /**
  * Import
  * - Store
  */
 import { RootState } from '../../../../../store'
 
 /**
  * Import
  * - Actions
  */
 import {
     setAnotherMarket,
     setUnderwriter,
     resetQuotes,
     resetQuoteVariation,
     issueQuoteVariation
 } from '../../../../../actions'
 
 /**
  * Import
  * - Page component
  */
 import Step05c from '../../../Quote/Step05c/Step05c'
 
 const mapStateToProps = (state: RootState, props: any) => {
 
     return {
         quote: state.quote,
         subjectivities: state.step05.subjectivities,
         marketStatus: state.step05.market,
         underwriterStatus: state.step05.underwriter,
         step05c: state.step05,
         request_rate: state.step05,
         stockBusinessAssets: get(state.quote, 'fullRenewals.response.renewal.stockBusinessAssets', {}),
         fullQuote: get(state.quote, 'fullRenewals.response.renewal', {}),
     }
 }
 
 export default connect(
     mapStateToProps,
     {
         quote: 'The QUOTE! Step02',
         setAnotherMarket: setAnotherMarket,
         setUnderwriter: setUnderwriter,
         issueQuoteVariation: issueQuoteVariation,
         resetQuotes: resetQuotes,
         resetQuoteVariation: resetQuoteVariation,
     }
 )(Step05c)
 


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Renewals/EditRenewals/containers/Step05c.tsx